"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "isModalOpen", {
    enumerable: true,
    get: function() {
        return isModalOpen;
    }
});
function isModalOpen(modal) {
    if (modal) {
        console.warn("modal parameter is deprecated");
    }
    return this.modal.classList.contains("open") || this.modal.hasAttribute("open");
}
